import { Pagination } from "./pagination";
import {
  AntecipacaoTransacao,
  AntecipacaoTransacaoGrid,
} from "./antecipacao-transacao";

export class SearchResult {
  pagination: Pagination;
  antecipacaoTransacoes: AntecipacaoTransacao[];
}

export class SearchResultGrid {
  pagination: Pagination;
  antecipacaoTransacoes: AntecipacaoTransacaoGrid[];
}
